import {Mitarbeiter} from 'shared/dtos/mitarbeiter';
import {RecordSummary} from 'shared/dtos/record-summary';
import {AdditionalInfo} from 'shared/dtos/wizard/additional-info';

export interface ValidationWorkerInputData {
  mitarbeiters: Mitarbeiter[];
  additionalInfo: AdditionalInfo;
  isForM2: boolean;
}

export enum ValidationWorkerOutputType {
  PROGRESS,
  RESULT
}

export interface ValidationWorkerOutputData {
  type: ValidationWorkerOutputType;
}

export interface ValidationWorkerOutputResult extends ValidationWorkerOutputData {
  type: ValidationWorkerOutputType.RESULT;
  mitarbeiters: Mitarbeiter[];
  additionalInfo: AdditionalInfo;
  statusFigures: RecordSummary;
}

export interface ValidationWorkerOutputProgress extends ValidationWorkerOutputData {
  type: ValidationWorkerOutputType.PROGRESS;
  progressPercent: number;
  index: number;
  total: number;
  passedTimeMs: number;
}
